import { useCallback, useEffect } from "react";
import { useLocation } from "react-router-dom";

function PageChangeHandler() {
    const location = useLocation();
    const retryScrollLimit = 100;
    let retryScrollCount = 0;

    const onLoad = useCallback(() => {
        window.scrollTo(0, 0);
        if (location.hash) {
            const tryScroll = () => {
                if (++retryScrollCount < retryScrollLimit) {
                    const target = document.querySelector(
                        `[data-scroll="${location.hash.substring(1)}"]`
                    );
                    if (target) {
                        target.scrollIntoView({
                            behavior: "smooth",
                            block: "start",
                        });
                    } else {
                        // Retry until found
                        requestAnimationFrame(tryScroll);
                    }
                }
            };
            requestAnimationFrame(tryScroll);
        }
    }, [location, retryScrollCount]);

    useEffect(() => {
        onLoad();
    }, [onLoad]);

    return null;
}

export default PageChangeHandler;
